exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.notes-wrapper[data-v-6fb5363f] .v-textarea {\n  background-color: transparent;\n}\n.notes-wrapper[data-v-6fb5363f] .v-field {\n  background-color: #f8f9fa !important;\n}\n.notes-wrapper[data-v-6fb5363f] .v-field__field {\n  background-color: #f8f9fa !important;\n}\n.notes-wrapper[data-v-6fb5363f] .v-field__input {\n  background-color: transparent !important;\n}\n", ""]);

// exports
